<template>
  <div id="footer_menu1" class="hoc clear" style="width: 100%; background: #198754cf; margin-top: 10px">
    <footer class="row_footer1" style="padding-top:2% ; padding-bottom: 2%;">
       <div class="col_footer1_menu w-25 ">
        <div class="footer-bolck footer-bolck--0 mt-4 textcty" >
          <div class="footer-bolck__item">
            <span href="/"><strong>{{ currentLanguage.footer_text_tenCty }}</strong>
              <img src="img/footer/logovimass.png"
                style="width: 62px; vertical-align: inherit; margin-left: 10px" /></span>
          </div>
          <div class="footer-bolck__item" style="color: white;">
            <span>{{ currentLanguage.footer_text_hoiSoHaNoi }}</span>
          </div>
        </div>
      </div>
      <div class="col_footer1_menu w-25 mt-3">
        <div class="d-flex justify-center">
          <a href="https://play.google.com/store/apps/details?id=com.qr.vivimass" target="_blank" style="
              text-align: left;
              border: 6px solid #fff;
              border-radius: 10px;
            ">
            <img style="border-radius: 5px; width: 100px;"
              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1772698605066odwoF" />
          </a>
          <div class="d-flex flex-column justify-space-around" style="margin-left: 10px">
            <!-- <img
              class="imgqr"
              style="width: 50px; margin: auto"
              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1724991198092JzTvF"
            /> -->
            <span style="font-size: 18px; font-weight: 600 ; color: #fff;"> VIMASS </span>
            <a href="https://apps.apple.com/vn/app/v%C3%AD-vimass/id6448410181?l=vi" target="_blank"
              style="text-align: left">
              <img class="imgqr"
                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=16957034549947vdJF" />
            </a>

            <a href="https://play.google.com/store/apps/details?id=com.qr.vivimass" target="_blank"
              style="text-align: left; margin-top: 10px">
              <img class="imgqr"
                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1695703486057vHWBF" />
            </a>
          </div>
        </div>
      </div>

      <div class="col_footer1_menu w-25 mt-3">
        <div class="item-menu item-menu--style">
          <a class="m-auto">
            <img src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1774514633113FPCoF" style="width: 87px; height: 87px" />
          </a>

          <a style="color: white;" class="mt-2">
            Hungarian National Bank
            <!-- {{ currentLanguage.footer_text_row_footer1_nganHang }}
            <br />
            {{ currentLanguage.footer_text_row_footer1_giayPhep }} -->
          </a>
        </div>
      </div>
     

      <div class="col_footer1_menu w-25 mt-3">
        <div class="d-flex flex-column">
          <span style="font-size: 15px !important; color: white;" class="m-auto">
            {{ currentLanguage.footer_text_LienHe }}
          </span>
          <div class="d-flex justify-content-around mt-2">
            <a href="https://zalo.me/2351532103457395203" target="_blank">
              <img src="img/icon/zalo.png" />
            </a>
            <a href="http://m.me/vimasscorp" target="_blank">
              <img src="img/icon/mess.png" />
            </a>
          </div>
          <div class="d-flex justify-content-around mt-2">
            <a href="https://mail.google.com/mail/?view=cm&fs=1&to=cskh.vimass@gmail.com"
              style="color: white; font-size: 16px" target="_blank">
              <img src="img/icon/email.png" alt="Email Icon" />
              cskh.vimass@gmail.com
            </a>
          </div>
        </div>
        <!-- <div class="w-100 text-center">
          <a class="me-10p" href="https://qrvn.vn/" target="_blank"
            >{{
              currentLanguage.footer_text_row_footer1_xemThem
            }}https://qrvn.vn</a
          >
        </div>
        <div class="w-100 text-center">
          <a class="me-10p" href="https://vimass.vn/vidientu" target="_blank"
            >{{
              currentLanguage.footer_text_row_footer1_xemThem
            }}
            https:/vimass.vn/vidientu</a
          >
        </div> -->
      </div>
    </footer>

    <footer id="footer" class="hoc clear " style="background: #198754; float: none">
      <!-- ################################################################################################ -->
      <div class="container-footer">
        <div class="footer-bolck footer-bolck--0 mt-4 d-none" >
          <div class="footer-bolck__item">
            <span href="/"><strong>{{ currentLanguage.footer_text_tenCty }}</strong>
              <img src="img/footer/logovimass.png"
                style="width: 62px; vertical-align: inherit; margin-left: 10px" /></span>
          </div>
          <div class="footer-bolck__item">
            <span>{{ currentLanguage.footer_text_hoiSoHaNoi }}</span>
          </div>


        </div>
        <div class="footer-bolck footer-bolck--1 d-none">
          <div class="footer-bolck__item">
            <a id="urlFooterChuongTrinhTaiTro" href="vi/thanhtoanthongminh" target="_blank">
              <i class="fas fa-caret-right" style="color: #ffffff"></i>
              {{ currentLanguage.item_footer_0 }}
            </a>
          </div>
          <div class="footer-bolck__item">
            <a id="urlFooterDiemThanhToan" href="vi/thesinhtrachoc" target="_blank">
              <i class="fas fa-caret-right" style="color: #ffffff"></i>
              {{ currentLanguage.footer_text_theVimass }}
            </a>
          </div>

          <div class="footer-bolck__item">
            <a id="urlFooterThietBi" href="vi/daudocbantay" target="_blank">
              <i class="fas fa-caret-right" style="color: #ffffff"></i>
              {{ currentLanguage.footer_text_daudocbantay }}
            </a>
          </div>
          <div class="footer-bolck__item">
            <a id="urlFooterTheDaNang" href="vi/congty" target="_blank">
              <i class="fas fa-caret-right" style="color: #ffffff"></i>
              {{ currentLanguage.footer_text_cty }}
            </a>
          </div>
        </div>

        <div class="footer-bolck footer-bolck--2 d-none">
          <div class="d-flex flex-column">
            <span style="font-size: 15px !important" class="m-auto">
              {{ currentLanguage.footer_text_LienHe }}
            </span>
            <div class="d-flex justify-content-around mt-2">
              <a href="https://zalo.me/2351532103457395203" target="_blank">
                <img src="img/icon/zalo.png" />
              </a>
              <a href="http://m.me/vimasscorp" target="_blank">
                <img src="img/icon/mess.png" />
              </a>
            </div>
            <div class="d-flex justify-content-around mt-2">
              <a href="https://mail.google.com/mail/?view=cm&fs=1&to=cskh.vimass@gmail.com"
                style="color: white; font-size: 16px" target="_blank">
                <img src="img/icon/email.png" alt="Email Icon" />
                cskh.vimass@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- ################################################################################################ -->
    </footer>
  </div>
</template>
<script>
import { languages } from "@/assets/js/languagesVMHU";

export default {
  data() {
    return {
      currentLanguage: languages.hu,
    };
  },
  created() {
    const savedLanguage = localStorage.getItem("languages") || "hu";
    if (savedLanguage && languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }
  },
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
    },
  },
};
</script>
<style scoped> 
.textcty{
  text-align: left;
}
@media (max-width: 768px) {
  .textcty {
    text-align: center;
  }
}

</style>
